import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Appointment from './Appointment';

const AppointmentListSection = (
  {
    appointments,
    dates,
    emptyMessage,
    className,
    title,
    onAppointmentCancel
  }
) => (
  <div className={classNames('appointment-list-section', className)}>
    <div className='appointment-list-section-header'>
      <span className='appointment-list-section-header-title'>
        {title}
      </span>
      <span className='appointment-list-section-header-date'>
      (
        {dates}
      )
      </span>
    </div>
    {
      appointments.length > 0
        ? appointments.map((appointment) => (<Appointment {...appointment} key={appointment.id} onCancel={onAppointmentCancel} />))
        : <span className='appointment-list-empty'>{emptyMessage}</span>
    }
  </div>
);

AppointmentListSection.propTypes = {
  /** A list of appointments to be shown in this section */
  appointments: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string })),

  /** The date or dates for this section */
  dates: PropTypes.string,

  /** A message to show when this section is empty */
  emptyMessage: PropTypes.string,

  /**  A class name applied to this section */
  className: PropTypes.string,

  /** The title for the section */
  title: PropTypes.string,

  /** Called on an appointment when it is cancelled */
  onAppointmentCancel: PropTypes.func
};

AppointmentListSection.defaultProps = {
  appointments: [],
  dates: '',
  emptyMessage: 'There are no appointments scheduled.',
  className: '',
  title: '',

  onAppointmentCancel: () => false
};

export default AppointmentListSection;
